/**
 * Representação do curso enquanto item de carrinho/checkout.
 * O conteúdo real (módulos, aulas, vídeos) vive no backend (loja-api/courseData.ts).
 *
 * IMPORTANTE: `price`/`originalPrice` aqui são FALLBACK. O preço real é o
 * `priceCents` do tier ativo (vindo de GET /api/course) — Curso.js sobrescreve
 * esses campos no addToCart. Não confie nesses valores em tela.
 */
export const COURSE_PRODUCT = {
  id: 'curso-fingerstyle-catolico',
  type: 'course',
  title: 'Curso de Fingerstyle Católico',
  price: 10700, // fallback: preço de lançamento
  originalPrice: 29700, // fallback: preço cheio
  image: '/capaEbooksLoja/capaCurso.png',
  category: 'Curso',
  description:
    'Curso completo de violão fingerstyle para católicos — do básico ao avançado, aplicado às músicas que tocamos na missa, adoração e oração.',
};
